// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "b87621f26cf36b3e5b3f086c6cf937a2" + ".js";
};